'use strict';
const angular = require('angular');
import routes from './admin.routes';
import AdminController from './admin.controller';
import signup from './signup';
import configurations from './configurations/';
// import authModule from '../../components/auth/auth.module';

export default angular.module('nomasvelloDashboardApp.admin', [
  // authModule,
  'ngRoute',
  signup,
  configurations
])
  .config(routes)
  .controller('AdminController', AdminController)
  .name;



// WEBPACK FOOTER //
// ./client/app/admin/index.ts